import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { DOCUMENT_TYPE_CONFIG_BY_COMMUNITY } from "./apiRoutes";

const mutateAddDocumentType = async ({
  data,
}: {
  data: FieldValues;
}) => {
  return await axiosAuth.post(
    DOCUMENT_TYPE_CONFIG_BY_COMMUNITY(data?.communityId),
    data
  );
};

const useAddDocumentTypeMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddDocumentType,
    ...queryParams,
  });

export default useAddDocumentTypeMutation;
